import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, CanActivate,
  RouterStateSnapshot, UrlTree,
} from '@angular/router';


import { FsMessage, MessageMode } from '@firestitch/message';
import { FsForcePasswordChange } from '@firestitch/password-reset';

import { SigninService } from '@app/core';


@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard implements CanActivate {

  constructor(
    private _forcePasswordChange: FsForcePasswordChange,
    private _message: FsMessage,
    private _signinService: SigninService,
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this._signinService.signedIn()) {
      this._message.error('Your session has expired. Please signin again.',
        { mode: MessageMode.Toast });

      return this.createSigninUrlTree();
    }

    return null;
  }

  public createSigninUrlTree(): UrlTree {
    return this._signinService.createSigninUrlTree();
  }

}
